// Отслеживание видимого вьюпорта (iOS-клавиатура).
//
// Проблема: на iOS Safari (таб и standalone) открытая клавиатура НЕ ресайзит
// layout-вьюпорт — 100dvh остаётся прежним, и композер уезжает под клавиатуру.
// `interactive-widget=resizes-content` iOS не поддерживает, поэтому единственный
// надёжный путь — visualViewport: пишем его высоту в CSS-переменную --app-height
// на <html>, а корневой контейнер использует `height: var(--app-height, 100dvh)`
// (фолбэк 100dvh — для браузеров без visualViewport и до первого замера).
//
// Детали:
// - vv.scale !== 1 (pinch-zoom) игнорируем — иначе зум схлопывает лейаут;
// - vv.offsetTop > 0: Safari-таб сдвигает страницу вверх при фокусе поля —
//   возвращаем на место, композер и так прижат переменной высотой;
// - при изменении высоты диспатчим 'app:viewport-resized' — экран чата по нему
//   доскролливает ленту вниз, если она была прилипшей к низу.

let started = false;

export function initViewportTracking() {
  if (started || typeof window === 'undefined' || !window.visualViewport) {
    return;
  }
  started = true;

  const vv = window.visualViewport;
  let frame = null;
  let lastHeight = 0;

  const apply = () => {
    frame = null;
    if (vv.scale !== 1) {
      return;
    }
    const height = Math.round(vv.height);
    if (height > 0 && height !== lastHeight) {
      lastHeight = height;
      document.documentElement.style.setProperty('--app-height', `${height}px`);
      window.dispatchEvent(new CustomEvent('app:viewport-resized', { detail: { height } }));
    }
    if (vv.offsetTop > 0) {
      window.scrollTo(0, 0);
    }
  };

  const schedule = () => {
    if (frame === null) {
      frame = window.requestAnimationFrame(apply);
    }
  };

  vv.addEventListener('resize', schedule);
  vv.addEventListener('scroll', schedule);
  schedule();
}

// Клавиатура «съедает» низ visualViewport, не трогая layout-вьюпорт, — разница
// высот и есть единственный доступный признак того, что она сейчас на экране.
// Порог с запасом: панель предиктивного ввода iOS одна занимает ~45px.
const KEYBOARD_MIN_INSET_PX = 120;

export function isKeyboardVisible() {
  if (typeof window === 'undefined' || !window.visualViewport) {
    return false;
  }
  const vv = window.visualViewport;
  if (vv.scale !== 1) {
    return false;
  }
  return window.innerHeight - vv.height > KEYBOARD_MIN_INSET_PX;
}
